// extracted by mini-css-extract-plugin
export var messageSideLeft = "_l6-1";
export var messageSideRight = "_l6-2";
export var orderLookupBubbleContainer = "_l6-0";
export var submitButton = "_l6-3";